module.exports = __webpack_public_path__ + "app/principal/seller-relations-3Ka5iBQe.html";